import dayjs from 'dayjs';
let customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

function formatDate(date) {
    if (date) {
        return dayjs(date).format("DD/MM/YYYY");
    }
}

function formatDateRequest(date) {
    if (date) {
        return dayjs(date).format("YYYY-MM-DD");
    }
}

function compareDate(dateDebut, dateFin) {
    if (new Date(dateDebut) > new Date(dateFin)){
        // document.getElementById("errorDate").style.display = "block";
        return false
    }else{
        // document.getElementById("errorDate").style.display = "none";
        return true
    }
}

function formatDateRequestHours(date) {
    if (date) {
        return dayjs(date).format("HH:mm");
    }
}

function formatDateLetter(date){
    if(date){
        return dayjs(date).format("DD MMMM YYYY");
    }
}

function formatTypeDate(date) {
    if (date) {
        return date.split("T")[0];
    }
}

function determinePayementState(date){
    if(dayjs().isAfter(date)){
        return "Payé";
    }else{
        return "A venir";
    }
}

function determineRenduState(date){
    if(dayjs().isAfter(date)){
        return true;
    }else{
        return false;
    }
}

function now(){
    return dayjs();
}

function dateExists(date){
    if(date==="1970-01-01"){
        return null;
    }else{
        return date;
    }
}

function formatDateHours(date){
    if (date) {
        return dayjs(date).format("DD/MM/YYYY HH:mm");
    }
}

function formatHours(date){
    console.log(date)
}

export default {
    formatDate,
    determinePayementState,
    now,
    determineRenduState,
    formatTypeDate,
    dateExists,
    formatDateRequest,
    formatDateLetter,
    formatDateRequestHours,
    compareDate,
    formatDateHours,
    formatHours
}
